import { combineEpics } from 'redux-observable';

import { findReportsEpic }    from './FindReports/FindReportsEpic';
import { findReportEpic }     from './FindReport/FindReportEpic';
import { downloadReportEpic } from './DownloadReport/DownloadReportEpic';
import { deleteReportEpic }   from './DeleteReport/DeleteReportEpic';


export default combineEpics(
  findReportsEpic,
  findReportEpic,
  downloadReportEpic,
  deleteReportEpic,
);
